export enum AppArchitecture {
  Intel = "x64",
  Arm64 = "arm64",
}
